import { Component, OnInit } from '@angular/core';

import { Fai, FaimUnlimited, Plan, ProductFactory, QuoteModel } from '@bytel/bytel-sales';

import { CmsBlockComponent } from '@base/common/components/cms-block/cms-block.component';
import { REINSURANCE_TYPES } from '@base/common/constants';

import { MainCartService } from '@services/main-cart.service';

@Component({
    selector: 'checkout-reinsurance',
    templateUrl: './reinsurance.component.html',
    styleUrl: 'reinsurance.component.scss',
    standalone: true,
    imports: [CmsBlockComponent],
})
export class ReinsuranceComponent implements OnInit {
    public choicesByType = {
        [REINSURANCE_TYPES.DEFAULT]: 'checkout/reassurancevide',
        [REINSURANCE_TYPES.FAI]: 'fai/reassurance',
        [REINSURANCE_TYPES.MOBILE]: 'mobiles/reassurance',
    };
    public type: string = REINSURANCE_TYPES.DEFAULT;
    constructor(protected cartService: MainCartService) {}

    ngOnInit(): void {
        const quote: QuoteModel = this.cartService.getQuote();
        const plan: Plan = quote.getPrincipalProduct<Plan>('Plan');
        if (plan && (ProductFactory.Is(plan, Fai) || ProductFactory.Is(plan, FaimUnlimited))) {
            this.type = REINSURANCE_TYPES.FAI;
        } else if (plan) {
            this.type = REINSURANCE_TYPES.MOBILE;
        }
    }
}
